import React, { useEffect } from "react";
import { Chart } from "react-chartjs-2";
import { useTranslation, Trans } from "react-i18next";
import { useLocation } from "react-router-dom";
import bg_pc from "../../../assets/img/bg-pc-resize-tiny.png";
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import Button from "../../../components/Buttons/Button/Button";
import AnimatedLineChart from "../../../components/Charts/AnimatedLineChart";
import NavTo from "../../../components/NavTo/NavTo";
import styles from "../../../index.scss";
import routes from "../../../utils/routes.json";
import "./PresentationPage.scss";
import playIcon from "../../../assets/img/play.png";

function PresentationPage() {
  const location = useLocation();

  useEffect(() => {
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.backgroundColor = styles.primaryColor;
    return () => {
      document.body.style.backgroundColor = "";
    };
  }, []);

  const { t } = useTranslation();

  const data = {
    labels: ["Red", "Blue", "Yellow"],
    datasets: [
      {
        data: [300, 50, 100],
        backgroundColor: [
          "rgb(255, 99, 132)",
          "rgb(54, 162, 235)",
          "rgb(132,104,239)",
        ],
        borderWidth: 0,
        borderRadius: 5,
        spacing: 5,
        hoverOffset: 8,
      },
    ],
  };

  const data2 = {
    labels: ["Red", "Blue", "Purple"],
    datasets: [
      {
        data: [30, 140, 70],
        backgroundColor: [
          "rgb(255, 99, 132)",
          "rgb(54, 162, 235)",
          "rgb(132,104,239)",
        ],
        borderWidth: 0,
        borderRadius: 5,
        spacing: 5,
        hoverOffset: 8,
      },
    ],
  };

  const options = {
    responsive: true,
    cutout: '80%',
    plugins: {
      legend: false,
      tooltip: {
        enabled: false,
      },
    },
    animation: {
      animateScale: true,
      animateRotate: true,
      delay: 800
    }
  };

  return (
    <div className="homePage">
      <svg fill="none" className="bg-svg">
        <path
          d="M0 -217L2160.5 1200L2303.5 -158.5L0 -217Z"
          fill="url(#paint0_linear)"
        ></path>
        <defs>
          <linearGradient
            id="paint0_linear"
            x1="611.5"
            y1="564"
            x2="2230.5"
            y2="276.5"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#36A2EB" stopOpacity="0.15"></stop>
            <stop offset="2" stopColor="#FF6384" stopOpacity="0.35"></stop>
          </linearGradient>
        </defs>
      </svg>

      <div className="homePage-main">
        <div className="homePage-left">
          <div className="simpletype title-long">BOURSEPLAY</div>
          <div className="simpletype text-center title-letter">B</div>

          <div id="homePageFooter" className="homePageFooter">
            <div className="slogan">
              <Trans i18nKey="home.slogan" components={{ 1: <span className="highlight-keyword" /> }} />
            </div>
            <div className="phraseAccroche">{t("home.trigger")}</div>
            <div className="buttonDemoContainer">
              <NavTo className="custom-link" path={routes.demo}>
                <Button styles={"button black my-0 pl-3 pr-3 demo-button-styled"}>
                  <div className="d-flex align-center justify-center">
                    {t("home.demo")}
                    <img className="ml-4 demoIcon" src={playIcon} alt="playIcon" />
                  </div>
                </Button>
              </NavTo>
            </div>
          </div>
        </div>

        <div className="homePage-right">
          <div className="paper paper-1">
            <AnimatedLineChart />
          </div>

          <div className="paper paper-2">
            <Chart
              options={options}
              className={"doughnutChart"}
              type={"doughnut"}
              data={data}
            />
            <Chart
              options={options}
              className={"doughnutChart"}
              type={"doughnut"}
              data={data2}
            />
          </div>

          <div className="paper paper-3 badge-metric">
            <div className="badge-icon" style={{ background: 'rgba(16, 185, 129, 0.2)' }}>
              <TrendingUpIcon style={{ color: '#10b981' }} />
            </div>
            <div className="badge-text">
              <span className="badge-label">{t("home.profit")}</span>
              <span className="badge-value">+$452.10</span>
            </div>
          </div>

          <div className="paper paper-4 badge-metric">
            <div className="badge-icon" style={{ background: 'rgba(54, 162, 235, 0.2)' }}>
              <AccountBalanceWalletIcon style={{ color: '#3b82f6' }} />
            </div>
            <div className="badge-text">
              <span className="badge-label">{t("home.wallet_badge")}</span>
              <span className="badge-value" style={{ color: '#3b82f6' }}>$12,457</span>
            </div>
          </div>

          <div className="paper paper-5 badge-metric">
            <div className="badge-icon" style={{ background: 'rgba(139, 92, 246, 0.2)' }}>
              <TrackChangesIcon style={{ color: '#8b5cf6' }} />
            </div>
            <div className="badge-text">
              <span className="badge-label">{t("home.position")}</span>
              <span className="badge-value" style={{ color: '#8b5cf6' }}>$184.20</span>
            </div>
          </div>

          <div id="bg-pc" className="bg-pc">
            <img loading="lazy" src={bg_pc} alt={"tablet"} />
          </div>
        </div>
      </div>

      <div className="buttonsHomePage">
        <NavTo className="custom-link" path={routes.demo}>
          <Button styles={"button black my-0"}>
            <div className="d-flex align-center justify-center">
              {t("home.demo")}
              <img className="ml-4 demoIcon" src={playIcon} alt="playIcon" />
            </div>
          </Button>
        </NavTo>
        <NavTo className="custom-link" path={routes.auth} state={routes.login}>
          <Button children={t("header.login")} styles={"button black"} />
        </NavTo>
        <NavTo
          className="custom-link"
          path={routes.auth}
          state={routes.register}
        >
          <Button children={t("header.register")} styles={"button black"} />
        </NavTo>
      </div>
    </div>
  );
}

export default PresentationPage;
